import React, { useMemo } from 'react';
import TimeIcon from '@tradera/blueprint/theme/icons2/time.svg?jsx';
import PropTypes from 'prop-types';
import { useIsFeatureEnabled } from 'tradera/hooks/use-is-feature-enabled';
import useRecentSearches from 'tradera/hooks/use-recent-searches';
import Tags from '../tags/tags';
import { toSearchString } from 'tradera/utils/url';
import classnames from 'classnames';

const RecentSearchesTags = ({ inHeader, className }) => {
    const recentSearches = useRecentSearches();

    const tags = useMemo(
        () => getPreviousSearches(inHeader ? 7 : 16, recentSearches),
        [inHeader, recentSearches]
    );

    const isEnabled = useIsFeatureEnabled('recent-searches-tags');

    if (!isEnabled || !tags?.length) {
        return null;
    }

    return (
        <div
            className={classnames(
                'recent-searches-tags',
                'text-capitalize',
                {
                    'in-header': inHeader,
                    'mt-2 pb-2 ml-2 ml-lg-0': !inHeader
                },
                className
            )}>
            <Tags
                gaCategory="Recent Searches"
                gaAction="Navigation"
                scroll={!inHeader}
                tags={tags}>
                <TimeIcon
                    className={`icon mr-1 ${
                        inHeader
                            ? 'icon-white icon-md'
                            : 'icon-sm flex-shrink-0'
                    }`}
                    alt="Recent searches"
                />
            </Tags>
        </div>
    );
};

const getPreviousSearches = (limit, recentSearches) => {
    return recentSearches.slice(0, limit).map((item) => ({
        name: item.text,
        url: `/search${toSearchString(item.queryParams)}`
    }));
};

RecentSearchesTags.defaultProps = {
    className: ''
};

RecentSearchesTags.propTypes = {
    className: PropTypes.string,
    inHeader: PropTypes.bool.isRequired
};

export default RecentSearchesTags;
